/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoModelsCoupon,
    ControlcenterMelcoModelsCouponFromJSON,
    ControlcenterMelcoModelsCouponFromJSONTyped,
    ControlcenterMelcoModelsCouponToJSON,
    ControlcenterMelcoModelsCustomWarning,
    ControlcenterMelcoModelsCustomWarningFromJSON,
    ControlcenterMelcoModelsCustomWarningFromJSONTyped,
    ControlcenterMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsGenericList1MelcoModelsCoupon
 */
export interface ControlcenterMelcoModelsGenericList1MelcoModelsCoupon {
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsCoupon>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsCoupon
     */
    list: Array<ControlcenterMelcoModelsCoupon>;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsCustomWarning>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsCoupon
     */
    warning_list?: Array<ControlcenterMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsCoupon
     */
    total: number;
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsCouponFromJSON(json: any): ControlcenterMelcoModelsGenericList1MelcoModelsCoupon {
    return ControlcenterMelcoModelsGenericList1MelcoModelsCouponFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsCouponFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsGenericList1MelcoModelsCoupon {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(ControlcenterMelcoModelsCouponFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(ControlcenterMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsCouponToJSON(value?: ControlcenterMelcoModelsGenericList1MelcoModelsCoupon | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(ControlcenterMelcoModelsCouponToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(ControlcenterMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


